export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/testim-52b2fdf8d9c2608fde6840b91b30712b.png";